import { render, staticRenderFns } from "./SharedCollection.vue?vue&type=template&id=25deb55c&scoped=true&"
import script from "./SharedCollection.vue?vue&type=script&lang=js&"
export * from "./SharedCollection.vue?vue&type=script&lang=js&"
import style0 from "./SharedCollection.vue?vue&type=style&index=0&id=25deb55c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25deb55c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25deb55c', component.options)
    } else {
      api.reload('25deb55c', component.options)
    }
    module.hot.accept("./SharedCollection.vue?vue&type=template&id=25deb55c&scoped=true&", function () {
      api.rerender('25deb55c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/front/modules/share/components/SharedCollection.vue"
export default component.exports